module.exports = __webpack_public_path__ + "img/031-choose.d4737a3b.svg";